var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center overflow-auto"},_vm._l((_vm.filterOnlineUsers),function(u){return _c('online-user',{key:u,attrs:{"user-uid":u}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }